import { axiosMediaPrivate } from "./axios";
import {
  FilePreviewIdentifier,
  UploadPublicType,
} from "../types/types";
import { buildMediaDownloadPath } from "../utils/mediaDownloadUrl";

export const MediaApi = {
  download: async function (
    fileId: FilePreviewIdentifier,
    fileName?: string | null,
  ): Promise<any> {
    try {
      const res = await axiosMediaPrivate.get(
        buildMediaDownloadPath(fileId, fileName),
        {
        responseType: "blob",
        },
      );
      return res;
    } catch (error) {
      throw error;
    }
  },

  upload: async function (file: any): Promise<any> {
    try {
      const res = await axiosMediaPrivate.post(`/files`, file, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error) {
      throw error;
    }
  },

  uploadPublic: async function (payload: UploadPublicType): Promise<any> {
    try {
      const res = await axiosMediaPrivate.post(`files/public`, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return res;
    } catch (error) {
      throw error;
    }
  },

  delete: async function (ids: any): Promise<any> {
    try {
      const res = await axiosMediaPrivate.delete(`/files`, { data: ids });
      return res;
    } catch (error) {
      throw error;
    }
  },

  downloadChecklistTemplate: async function (fileName: string): Promise<any> {
    try {
      const res = await axiosMediaPrivate.get(
        `files/download-template?filename=${fileName}`,
        {
          responseType: "blob",
        },
      );
      return res;
    } catch (error) {
      throw error;
    }
  },
  downloadTemplateFile: async function (fileName: string): Promise<any> {
    try {
      const res = await axiosMediaPrivate.get(
        `files/download-template?filename=${fileName}`,
        {
          responseType: "blob",
        },
      );
      return res;
    } catch (error) {
      throw error;
    }
  },
  downloadFileErrorImportOkr: async function (
    fileId: string,
    fileName?: string | null,
  ): Promise<any> {
    try {
      const res = await axiosMediaPrivate.get(
        buildMediaDownloadPath(fileId, fileName),
        {
          responseType: "blob",
        },
      );
      return res;
    } catch (error) {
      throw error;
    }
  },
};

export function downloadFile(response: any, fallbackFileName?: string): void {
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const fileName = getFileNameInResponseHeader(response.headers) || fallbackFileName || "";
  const link = document.createElement("a");
  link.target = "_blank";
  link.download = fileName;
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 0);
}

export function getFileNameInResponseHeader(headers: any): string {
  const contentDisposition =
    headers?.["content-disposition"] || headers?.["Content-Disposition"];

  if (!contentDisposition) {
    return "";
  }

  const utf8Match = /filename\*=(?:UTF-8'')?([^;]+)/i.exec(contentDisposition);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"(.*)"$/, "$1"));
    } catch (_error) {
      return utf8Match[1].trim().replace(/^"(.*)"$/, "$1");
    }
  }

  const plainMatch = /filename="?([^"]+)"?/i.exec(contentDisposition);
  if (plainMatch?.[1]) {
    return plainMatch[1].trim();
  }

  return "";
}
